import * as APIModels from "../../../../models";
import { Modal, Button } from "react-bootstrap";

export type FilingPartyModalProps = {
    submission?: APIModels.Submission | undefined;
    show: boolean;
    onClose: () => void;
};

const FilingPartyModal = (params: FilingPartyModalProps) => {
    const filingPartyResponsible =
        params.submission?.caseData?.filingPartyResponsible;

    return (
        <Modal
            show={params.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Filing Party Responsible
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mt-4">
                    <div className="mt-1">
                        <input
                            name="filingPartyResponsibleInput"
                            className="form-control"
                            type="text"
                            id="filingPartyModalResponsible"
                            value={filingPartyResponsible ?? ""}
                            readOnly
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="filingPartyModalResponsible"
                        >
                            Filing Party Responsible
                        </label>
                    </div>
                </div>
                {!filingPartyResponsible && (
                    <div className="mt-2 text-muted">
                        No filing party responsible on this submission.
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={params.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FilingPartyModal;
